module.exports = __webpack_public_path__ + "experience/innovation/models/drone-base.b0fee89.obj";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/models/drone-base.obj
// module id = ht/0
// module chunks = 1